import { createApp, h, provide } from "vue";
import ImgixClient from '@imgix/js-core'
// import { ApolloClient } from 'apollo-client'
// import { createHttpLink } from 'apollo-link-http'
// import { InMemoryCache } from 'apollo-cache-inmemory'
import store from "./store.js";
import App from "./App.vue";

import {
	ApolloClient,
	createHttpLink,
	InMemoryCache
} from '@apollo/client/core';
import { DefaultApolloClient } from '@vue/apollo-composable';

const link = createHttpLink({ uri: '/api' });
const cache = new InMemoryCache();
const apolloClient = new ApolloClient({ link, cache, connectToDevTools: true });
const imgIXClient = new ImgixClient({
  domain: 't-marzetti.imgix.net',
  secureURLToken: 'MTVbgcQqPGDpycRh',
});

function waitForElement() {
	// console.log('b')
	if (typeof window.filterMode !== "undefined") {
		const mode = window.filterMode;
		// console.log('mode A', mode);
		const filterApp = createApp({
			setup() {
				provide(DefaultApolloClient, apolloClient);
			},
			render() {
				return h(App);
			}
		})
		filterApp.use(store)
		// filterApp.config.globalProperties.$FilterMode = 'recipe';
		filterApp.provide('mode', mode);
		filterApp.provide('imgIXClient', imgIXClient);
		filterApp.mount('#filter-app')
	}
	else {
		setTimeout(waitForElement, 250);
	}
}
waitForElement();

